import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface LanguageState {
  current: 'de' | 'en'
  available: string[]
}

const initialState: LanguageState = {
  current: 'de',
  available: ['de', 'en']
}

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<'de' | 'en'>) => {
      state.current = action.payload
    },
    addLanguage: (state, action: PayloadAction<string>) => {
      if (!state.available.includes(action.payload)) {
        state.available.push(action.payload)
      }
    }
  }
})

export const { setLanguage, addLanguage } = languageSlice.actions
export default languageSlice.reducer
